<template>
  <div class="search-holder">
    <v-text-field
      v-if="!isCustomerTab"
      color="black"
      flat
      dark
      solo-inverted
      hide-details
      clearable
      prepend-inner-icon="mdi-magnify"
      label="Recherche"
      @input="search"
    />
    <v-autocomplete
      v-else
      v-model="selectedCustomer"
      :search-input.sync="searchValue"
      color="black"
      flat
      dark
      solo-inverted
      hide-details
      clearable
      prepend-inner-icon="mdi-magnify"
      label="Recherche"
      :items="autoCompleteCustomers"
      no-filter
      item-text="fullname"
      item-value="uuid"
      :menu-props="{ 'z-index': '1500 !important'}"
      :loading="loading"
      :disabled="loading"
      @keyup.enter="searchOnAlgolia"
      @change="selectItem"
      @update:search-input="updateSearchInput"
    >
      <template #item="data">
        <v-row>
          <v-col cols="10">{{ data.item.fullname }}</v-col>
          <v-col v-if="data.item.showMoreButton" cols="2">
            <v-btn icon @click.stop="selectCustomer(data.item)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template #append-item>
        <div style="padding: 0 16px;" class="text-center">
          <v-btn color="light-blue" @click="reddirectToCRM">
            Etendre la recherche à la base Contact
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { ref, computed, nextTick } from '@vue/composition-api';
import { separateContentTypesWithAndWithoutSession } from '@/helpers/dataManager';
import store from '@/store';
import { searchCustomerOnAlgolia, searchLocalCustomers } from '@/helpers/search';
import { EventBus } from '@/helpers/utils';

export default {
  setup () {
    const searchValue = ref(null);

    const currentTab = computed(() => store.state.currentTab);
    const workspace = computed(() => store.state.workspace);
    const algoliaCustomers = computed(() => store.state.algoliaCustomers);
    const selectedCustomers = computed(() => store.state.selectedCustomers);

    const customersWithSession = computed(() => {
      const customers = separateContentTypesWithAndWithoutSession('customer');

      return customers.with_session;
    });

    const isCustomerTab = computed(() => currentTab.value === 'customer');

    const autoCompleteCustomers = computed(() => {
      const returnValue = [];

      customersWithSession.value.map(customer => {
        returnValue.push({ ...customer });
      });

      algoliaCustomers.value.map(customer => {
        const exist = selectedCustomers.value.find(c => c.uuid === customer.uuid);
        returnValue.push({
          ...customer,
          showMoreButton: !exist
        });
      });

      const customers = returnValue.map(c => ({
        uuid: c.uuid,
        firstname: c.firstname,
        lastname: c.uuid,
        fullname: c.fullname
      }));

      if (searchValue.value) {
        const result = searchLocalCustomers(searchValue.value, customers);

        return returnValue.filter(c => result.some(r => r?.item?.uuid === c.uuid));
      }

      return returnValue;
    });

    const loading = ref(false);

    const search = value => {
      if (!isCustomerTab.value) {
        store.commit('setSearch', value);
      }
    };

    const selectedCustomer = ref(null);

    const reddirectToCRM = () => {
      const workspaceValue = workspace.value.code.split('_test')[0];
      let url = `${process.env.VUE_APP_CRM_URL}?returnTo=pegase&workspace=${workspaceValue}`;

      if (searchValue.value) {
        url += `&query=${searchValue.value}`;
      }
      window.location.href = url;
    };

    const selectItem = () => {
      nextTick(() => {
        // selectedCustomer.value = null;
      });
    };

    const updateSearchInput = () => {
      store.commit('setSearch', searchValue.value);
    };

    const searchOnAlgolia = async () => {
      searchCustomerOnAlgolia(searchValue.value);
    };

    const selectCustomer = customer => {
      const alreadyExist = selectedCustomers.value.find(c => c.uuid === customer.uuid);

      if (!alreadyExist) {
        store.commit('setSelectedCustomer', { ...customer, fullname: `${customer.firstname} ${customer.lastname}` });
      }

      EventBus.$emit('changeFolderPanel');
    };

    return { selectCustomer, searchOnAlgolia, search, isCustomerTab, autoCompleteCustomers, reddirectToCRM, searchValue, selectItem, selectedCustomer, loading, updateSearchInput };
  }
};
</script>

<style>

.search-holder {
  position: relative;
  width: 100%;
  max-width: 500px;
}
</style>
